<div
  class="gl-select"
  [ngClass]="{ min: size === 'min', small: size === 'small', large: size === 'large' }"
>
  <div
    class="gl-select-item"
    [ngClass]="{ open: openSelect, disabled: disabled }"
    (click)="toogleSelect()"
  >
    <span class="gl-selected-item" [ngClass]="{ placeholder: !selectedItem }">{{
      selected | translate
    }}</span>
    <span class="glicon-down"></span>
    <div ref="container" class="gl-dropdown">
      <div
        *ngFor="let item of items; let i = index"
        class="gl-dropdown__option"
        [ngClass]="{ disabled: item.disabled }"
        (click)="selectItem(item)"
      >
        {{ item.value | translate }}
      </div>
    </div>
  </div>
</div>
